import React from 'react';
import { Grid, Box, Typography } from '@mui/material';

import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    titleContainer: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
});

class SettingsPanelSection extends React.Component {
    render() {
        const { classes, title, action, children, id} = this.props

        return (
            <Box id={id}>
                <Grid 
                    container
                    direction='row'
                    justifyContent='space-between'
                    alignItems='center'
                    className={classes.titleContainer}
                >
                    <Grid>
                        <Typography
                            variant='h6'
                            align='left'
                        >
                            {title}
                        </Typography>
                    </Grid>
                    <Grid>
                        {action}
                    </Grid>
                </Grid>
                {children}
            </Box>
        );
    }
}

export default withStyles(SettingsPanelSection, styles);